module.exports = __webpack_public_path__ + "static/media/upload.c0c68708.svg";